<template>
    <div class="animated fadeIn efficiency">
        <filters :scope="filtersScope">
        </filters>
        <div class="container-fluid">
            <div>
                <div class="card-block"  v-if="loading">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="logout-message" style="text-align: center;">{{ $t('message.loading') }}
                                <i aria-hidden="true" class="fa fa-spinner fa-spin"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <form @submit="checkForm" id="formRent" v-else>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-header-title" v-if="title">
                                {{ title }}
                                <button class="btn btn-success btn-lg btn-check" style="float: right">
                                    <i class="fa fa-check-circle"></i>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="statistic-wrap">
                        <div v-if="allCountry">
                            <div class="card statistic-table statistic-table-balance">
                                <div v-for="(rowsDate,indexCountry) in rowsAll">
                                    <div class="card-header">
                                        {{ Helper.findCountryName(indexCountry) }}
                                    </div>
                                    <div class="card-block card-zz">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th :colspan="col.colspan" :style="renderBackground(false, col.field, false)" :width="col.width ? col.width : 'auto'"  v-for="col in computedHeadColumns">{{ col.label }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(row, i) in rowsDate">
                                                <td>{{row.month}}</td>
                                                <td style="background-color: #fff9c4;">{{row.leads}}</td>
                                                <td style="background-color: #b9f6ca;">{{(row.approved_percent * 100).toFixed(2)}}%</td>
                                                <td style="background-color: #c8e6c9;">{{row.approved}}</td>
                                                <td style="background-color: #c8cce6;">{{row.expenses_by_kc}}</td>
                                                <td @change="changeElem()" style="background-color: #90caf9" v-if="date === row.dateByRows && row.isChanged">
                                                    <input :id="'m'+row.dateByRows" :name="'c'+ row.country_id" value="-" class="input-price" type="text">
                                                </td>
                                                <td @change="changeElem()" style="background-color: #90caf9" v-else>
                                                    <input :id="'m'+row.dateByRows" :name="'c'+ row.country_id" :value="row.expenses_by_lead" class="input-price" type="text">
                                                </td>
                                                <td style="background-color: #e0e0e0;" v-if="date === row.dateByRows && row.country_id !== 77">$ {{row.expected_lead_increase}}</td>
                                                <td style="background-color: #e0e0e0;" v-else-if="date === row.dateByRows && row.country_id === 77">₽ {{row.expected_lead_increase}}</td>
                                                <td style="background-color: #e0e0e0;" v-else> - </td>
                                                <td style="background-color: #ef9a9a" v-if="date !== row.dateByRows">{{row.cost_change_other_month}}%</td>
                                                <td style="background-color: #ef9a9a" v-else-if="date === row.dateByRows">{{row.cost_change_current_month}}%</td>
                                            </tr>
                                            </tbody>
                                            <tfoot>
                                            <tr>
                                                <th>Итого:</th>
                                                <th style="background-color: #fff9c4">{{footAll[indexCountry].total}}</th>
                                                <th style="background-color: #b9f6ca">{{footAll[indexCountry].totalApprovedPercent}}%</th>
                                                <th style="background-color: #c8e6c9">{{footAll[indexCountry].totalApproved}}</th>
                                                <th style="background-color: #c8cce6">{{footAll[indexCountry].totalKc}}</th>
                                                <th style="background-color: #90caf9"><span></span></th>
                                                <th style="background-color: #e0e0e0"><span></span></th>
                                                <th style="background-color: #ef9a9a"><span></span></th>
                                            </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card statistic-table statistic-table-balance" v-else>
                            <div class="card-header" v-if="title">
                              <span v-for="name in countryTitle">{{ name }}</span>
                            </div>
                            <div class="card-block card-zz">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th :colspan="col.colspan" :style="renderBackground(false, col.field, false)" :width="col.width ? col.width : 'auto'"  v-for="col in computedHeadColumns">{{ col.label }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="cell in rows">
                                        <td>{{cell.month}}</td>
                                        <td style="background-color: #fff9c4;">{{cell.leads}}</td>
                                        <td style="background-color: #b9f6ca;">{{(cell.approved_percent * 100).toFixed(2)}}%</td>
                                        <td style="background-color: #c8e6c9;">{{cell.approved}}</td>
                                        <td style="background-color: #c8cce6;">{{cell.expenses_by_kc}}</td>
                                        <td @change="changeElem()" style="background-color: #90caf9" v-if="date === cell.dateByRows && cell.isChanged">
                                            <input :id="'m'+cell.dateByRows" :name="'c'+ cell.country_id" value="-" class="input-price" type="text">
                                        </td>
                                        <td @change="changeElem()" style="background-color: #90caf9" v-else>
                                            <input :id="'m'+cell.dateByRows" :name="'c'+ cell.country_id" :value="cell.expenses_by_lead" class="input-price" type="text">
                                        </td>
                                        <td style="background-color: #e0e0e0;" v-if="date === cell.dateByRows && cell.country_id !== 77">$ {{cell.expected_lead_increase}}</td>
                                        <td style="background-color: #e0e0e0;" v-else-if="date === cell.dateByRows && cell.country_id === 77">₽ {{cell.expected_lead_increase}}</td>
                                        <td style="background-color: #e0e0e0;" v-else> - </td>
                                        <td style="background-color: #ef9a9a" v-if="date !== cell.dateByRows">{{cell.cost_change_other_month}}%</td>
                                        <td style="background-color: #ef9a9a" v-else-if="date === cell.dateByRows">{{cell.cost_change_current_month}}%</td>
                                        <td style="background-color: #8fbc8f">{{cell.approvedFromValid}}</td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr v-for="col in footColumns">
                                        <th>Итого:</th>
                                        <th style="background-color: #fff9c4"><span>{{ col.total }}</span></th>
                                        <th style="background-color: #b9f6ca">{{ (col.totalApprovedPercent * 100).toFixed(2)}}%</th>
                                        <th style="background-color: #c8e6c9"><span>{{ col.totalApproved }}</span></th>
                                        <th style="background-color: #c8cce6"><span>{{ col.totalKc }}</span></th>
                                        <th style="background-color: #90caf9"><span></span></th>
                                        <th style="background-color: #e0e0e0"><span></span></th>
                                        <th style="background-color: #ef9a9a"><span></span></th>
                                        <th style="background-color: #8fbc8f">{{col.approvedFromValid}}</th>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Filters from '../../../components/Filters.vue'
    import Helper from '../../../api/Helper'
    import TypeColor from '../../../assets/TypeColor'
    import Storage from '../../../api/Storage'
    import API from '../../../api/API'
    import StatisticTable from '../../../components/StatisticTable.vue'
    import { map, uniq } from 'lodash'

export default {
      name: 'ExpectedExpensesKC',
      components: {
        Filters,
        StatisticTable
      },
      data () {
        return {
          filtersScope: {
            monthFilter: true,
            byManualFilter: true
          },
          loading: false,
          Storage: Storage,
          TypeColor: TypeColor,
          Helper: Helper,
          rows: [],
          title: this.$root.$t('pages.expenses_by_kc'),
          oldValue: {},
          ChangeValue: String,
          countryTitle: [],
          headColumns: [
            {label: this.$root.$t('statistic.month'), width: '20%'},
            {label: this.$root.$t('statistic.leads'), field: 'leads', width: '11%'},
            {label: this.$root.$t('statistic.approve'), field: 'approved_rentabilty', width: '11%'},
            {label: this.$root.$t('statistic.approve_percent'), field: 'approved_percent', width: '11%'},
            {label: this.$root.$t('pages.expenses_by_kc'), field: 'expenses_by_kc', width: '11%'},
            {label: this.$root.$t('statistic.expenses_by_lead'), field: 'expenses_by_lead', width: '11%'},
            {label: this.$root.$t('statistic.expected_lead_increase'), field: 'expected_lead_increase', width: '11%'},
            {label: this.$root.$t('statistic.cost_change'), field: 'cost_change_other_month', width: '11%'},
            {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid'}
          ],
          date: null,
          footColumns: [],
          rowsAll: [],
          footAll: {},
          other: {},
          allCountry: false,
          month: {
            1: 'Январь',
            2: 'Февраль',
            3: 'Март',
            4: 'Апрель',
            5: 'Май',
            6: 'Июнь',
            7: 'Июль',
            8: 'Август',
            9: 'Сентябрь',
            10: 'Октябрь',
            11: 'Ноябрь',
            12: 'Декабрь'
          }
        }
      },
      computed: {
        computedHeadColumns () {
          if (!this.columns) {
            return this.headColumns
          } else {
            let headColumns = []
            this.headColumns.map((d) => {
              if (this.columns[d.field]) {
                headColumns.push(d)
              }
            })
            return headColumns
          }
        }
      },
      mounted () {
        this.getData()
        this.getCountry()
        this.$root.$on('filters_load_new_data', () => {
          this.getData()
          this.getCountry()
        })
      },
      methods: {
        renderBackground (cell, i, bc) {
          let style = !cell.style ? {} : cell.style
          if (!cell || (cell.bgg === undefined && !cell.dbgg)) {
            style.backgroundColor = !cell.bgc ? this.TypeColor[i] : cell.bgc
          } else {
            if (!cell.dbgg) {
              if (!cell.bgl) {
                style.background = `linear-gradient(to right, ${!cell.bggc ? this.TypeColor[i] : cell.bggc} ${cell.bgg}%, transparent 0%)`
              } else {
                style.background = `linear-gradient(to left, ${!cell.bggc ? this.TypeColor[i] : cell.bggc} ${cell.bgg}%, transparent 0%)`
                style.position = `relative`
              }
            } else {
              style.background = `linear-gradient(to right, ${this.TypeColor[cell.dbgg[0].name]} ${cell.dbgg[0].width}%, ${this.TypeColor[cell.dbgg[1].name]} ${cell.dbgg[0].width}%, ${this.TypeColor[cell.dbgg[1].name]} ${cell.dbgg[0].width + cell.dbgg[1].width}%, transparent 0%)`
            }
          }
          if (bc.bc) {
            style.backgroundColor = `${bc.bc}`
            style.color = bc.c
          }
          if (cell.bgColorTwo) {
            const summ = Math.abs(cell.bgColorTwo.max.value) + Math.abs(cell.bgColorTwo.min.value)
            const minPercent = ((Math.abs(cell.bgColorTwo.min.value) / summ) * 100).toFixed(0)
            const maxPercent = ((Math.abs(cell.bgColorTwo.max.value) / summ) * 100).toFixed(0)
            let percent
            if (cell.bgColorTwo.value < 0) {
              percent = (Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.min.value) * minPercent) + parseInt(maxPercent)
              style.background = `linear-gradient(to left, transparent 0%, transparent ${maxPercent}%, ${cell.bgColorTwo.min.color} ${maxPercent}%, ${cell.bgColorTwo.min.color} ${percent}%, transparent ${percent}%, transparent 100%)`
            } else {
              percent = (Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.max.value) * maxPercent) + parseInt(minPercent)
              style.background = `linear-gradient(to right, transparent 0%, transparent ${minPercent}%, ${cell.bgColorTwo.max.color} ${minPercent}%, ${cell.bgColorTwo.max.color} ${percent}%, transparent ${percent}%, transparent 100%)`
            }
            style.position = `relative`
          }
          return style
        },
        getData () {
          this.$root.$emit('data_loading')
          this.loading = true
          this.rows = []
          this.rowsAll = []
          this.footColumns = []
          this.footAll = {}
          API.getRentabilityExpenseExpection().then(res => {
            let date = new Date().getDate()
            let dateNow = new Date()
            let yearsNow = dateNow.getFullYear()
            let monthNow = dateNow.getMonth() + 1
            if (monthNow !== 10 || monthNow !== 11 || monthNow !== 12) {
              monthNow = `0${monthNow}`
            }
            this.date = yearsNow + '-' + monthNow
            let total = 0
            let count = 0
            let totalApproved = 0
            let otherKC = 0
            let totalAllKC = 0
            let totalApprovedPercent = 0
            let totalKc = 0
            let indexCur = 0
            let indexPrev = 0
            let pricePrev = 0
            let storageCountry = {}
            let leadIncrease = 0
            let objArr = []
            let arrNameCountry = []
            let totalSpam = 0
            if (Storage.selectedCountry.id === -1) {
              this.allCountry = true
              map(Storage.countries, stCountry => {
                map(res.body, (o, countryId) => {
                  let innCur = 0
                  let innPrev = 0
                  if (o.length === 1) {
                    pricePrev = Number(o[o.length - 1].price)
                  } else if (o.length > 1) {
                    pricePrev = Number(o[o.length - 2].price)
                  }
                  if (stCountry.id === parseInt(countryId)) {
                    map(o, (d, i) => {
                      if (!storageCountry[d.country_id]) {
                        storageCountry[d.country_id] = []
                      }
                      if (this.date === d.month) {
                        leadIncrease = Helper.leadIncrease(o[o.length - 1].price, o[o.length - 1].approved, o[o.length - 1].total, date, this.getDays(monthNow, yearsNow))
                      }
                      let fullMonth = d.month
                        /* if (!d.price) {
                      d.price = 0
                      totalKc += parseInt(d.price) * parseInt(d.approved)
                    } else {
                      totalKc += parseInt(d.price) * parseInt(d.approved)
                    } */
                      let monthIndex = parseInt(fullMonth.substr(5, 2))
                      let year = fullMonth.substr(0, 4)
                      if (parseInt(o[innCur].price) === 0 && parseInt(o[innPrev].price) === 0) {
                        storageCountry[d.country_id].push({
                          id: i,
                          dateByRows: d.month,
                          month: `${this.month[monthIndex]} ${year}`,
                          leads: parseInt(d.total),
                          approved_percent: `${(d.approved / d.total)}`,
                          approved: parseInt(d.approved),
                          expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                          expenses_by_lead: parseFloat(d.price),
                          expected_lead_increase: leadIncrease,
                          country_id: parseInt(d.country_id),
                          cost_change_other_month: 0,
                          cost_change_current_month: (((leadIncrease - pricePrev) / pricePrev) * 100).toFixed(2),
                          approvedFromValid: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                        })
                      } else if (parseInt(o[innPrev].price) === 0) {
                        storageCountry[d.country_id].push({
                          id: i,
                          dateByRows: d.month,
                          month: `${this.month[monthIndex]} ${year}`,
                          leads: parseInt(d.total),
                          approved_percent: `${(d.approved / d.total)}`,
                          approved: parseInt(d.approved),
                          expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                          expenses_by_lead: Number(d.price),
                          expected_lead_increase: leadIncrease,
                          country_id: parseInt(d.country_id),
                          cost_change_other_month: 0,
                          cost_change_current_month: (((leadIncrease - pricePrev) / pricePrev) * 100).toFixed(2),
                          approvedFromValid: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                        })
                      } else if (Number(d.price) === 0) {
                        let increaseForMonth = Number(o[innPrev].price) * Number(o[innPrev].approved) / ((Number(o[o.length - 1].total) / date) * this.getDays(monthNow, yearsNow) * (Number(d.approved) / Number(d.total)))
                        storageCountry[d.country_id].push({
                          id: i,
                          dateByRows: d.month,
                          month: `${this.month[monthIndex]} ${year}`,
                          leads: parseInt(d.total),
                          approved_percent: `${(d.approved / d.total)}`,
                          approved: parseInt(d.approved),
                          expenses_by_kc: (Number(o[innPrev].price) * parseInt(o[innPrev].approved)).toFixed(2),
                          expenses_by_lead: Number(o[innPrev].price),
                          expected_lead_increase: increaseForMonth.toFixed(2),
                          country_id: parseInt(d.country_id),
                          cost_change_other_month: 0,
                          cost_change_current_month: (((increaseForMonth - pricePrev).toFixed(3) / pricePrev) * 100).toFixed(2),
                          approvedFromValid: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam)),
                          isChanged: true
                        })
                      } else {
                        storageCountry[d.country_id].push({
                          id: i,
                          dateByRows: d.month,
                          month: `${this.month[monthIndex]} ${year}`,
                          leads: parseInt(d.total),
                          approved_percent: `${(d.approved / d.total)}`,
                          approved: parseInt(d.approved),
                          expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                          expenses_by_lead: Number(d.price),
                          expected_lead_increase: leadIncrease,
                          country_id: parseInt(d.country_id),
                          cost_change_other_month: (((o[innCur].price - o[innPrev].price) / o[innPrev].price) * 100).toFixed(2),
                          cost_change_current_month: (((leadIncrease - pricePrev) / pricePrev) * 100).toFixed(2),
                          approvedFromValid: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                        })
                      }
                      innPrev = innCur
                      if (innCur !== (o.length - 1)) {
                        innCur = innCur = innCur + 1
                      } else {
                        innCur = o.length - 1
                      }
                    })
                  }
                })
              })
            } else {
              map(res.body, o => {
                if (o.length === 1) {
                  pricePrev = Number(o[o.length - 1].price)
                } else if (o.length > 1) {
                  pricePrev = Number(o[o.length - 2].price)
                }
                map(o, (d, i) => {
                  this.allCountry = false
                  count = i + 1
                  if (this.date === d.month) {
                    leadIncrease = Helper.leadIncrease(o[o.length - 1].price, o[o.length - 1].approved, o[o.length - 1].total, date, this.getDays(monthNow, yearsNow))
                  }
                  if (indexCur === (o.length - 1)) {
                    indexCur = o.length - 1
                  }
                  let fullMonth = d.month
                  total += parseInt(d.total)
                  totalApprovedPercent += d.approved / d.total
                  totalApproved += parseInt(d.approved)
                  totalSpam += parseInt(d.spam)
                  if (Number(d.price) === 0) {
                    otherKC += Number(o[indexPrev].price) * parseInt(o[indexPrev].approved).toFixed(2)
                  } else {
                    totalKc += Number(d.price) * Number(d.approved)
                  }
                  totalAllKC = otherKC + totalKc
                  let monthIndex = parseInt(fullMonth.substr(5, 2))
                  let year = fullMonth.substr(0, 4)
                  let country = Helper.findCountry(parseInt(d.country_id))
                  this.countryTitle = country.name
                  if (parseInt(o[indexCur].price) === 0 && parseInt(o[indexPrev].price) === 0) {
                    this.rows.push({
                      id: i,
                      dateByRows: d.month,
                      month: `${this.month[monthIndex]} ${year}`,
                      leads: parseInt(d.total),
                      approved_percent: `${(d.approved / d.total)}`,
                      approved: parseInt(d.approved),
                      expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                      expenses_by_lead: parseFloat(d.price),
                      expected_lead_increase: leadIncrease,
                      country_id: parseInt(d.country_id),
                      cost_change_other_month: 0,
                      cost_change_current_month: (((leadIncrease - pricePrev) / pricePrev) * 100).toFixed(2),
                      approvedFromValid: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam)),
                      was_empty: parseInt(d.was_empty)
                    })
                  } else if (parseInt(o[indexPrev].price) === 0) {
                    this.rows.push({
                      id: i,
                      dateByRows: d.month,
                      month: `${this.month[monthIndex]} ${year}`,
                      leads: parseInt(d.total),
                      approved_percent: `${(d.approved / d.total)}`,
                      approved: parseInt(d.approved),
                      expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                      expenses_by_lead: Number(d.price),
                      expected_lead_increase: leadIncrease,
                      country_id: parseInt(d.country_id),
                      cost_change_other_month: 0,
                      cost_change_current_month: (((leadIncrease - pricePrev) / pricePrev) * 100).toFixed(2),
                      approvedFromValid: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                    })
                  } else if (Number(d.price) === 0) {
                    let increaseForMonth = Number(o[indexPrev].price) * Number(o[indexPrev].approved) / ((Number(o[o.length - 1].total) / date) * this.getDays(monthNow, yearsNow) * (Number(d.approved) / Number(d.total)))
                    this.rows.push({
                      id: i,
                      dateByRows: d.month,
                      month: `${this.month[monthIndex]} ${year}`,
                      leads: parseInt(d.total),
                      approved_percent: `${(d.approved / d.total)}`,
                      approved: parseInt(d.approved),
                      expenses_by_kc: (Number(o[indexPrev].price) * parseInt(o[indexPrev].approved)).toFixed(2),
                      expenses_by_lead: Number(o[indexPrev].price),
                      expected_lead_increase: increaseForMonth.toFixed(3),
                      country_id: parseInt(d.country_id),
                      cost_change_other_month: 0,
                      cost_change_current_month: ((increaseForMonth - pricePrev).toFixed(3) / pricePrev * 100).toFixed(2),
                      approvedFromValid: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam)),
                      isChanged: true
                    })
                  } else {
                    this.rows.push({
                      id: i,
                      dateByRows: d.month,
                      month: `${this.month[monthIndex]} ${year}`,
                      leads: parseInt(d.total),
                      approved_percent: `${(d.approved / d.total)}`,
                      approved: parseInt(d.approved),
                      expenses_by_kc: (Number(d.price) * parseInt(d.approved)).toFixed(2),
                      expenses_by_lead: Number(d.price),
                      expected_lead_increase: leadIncrease,
                      country_id: parseInt(d.country_id),
                      cost_change_other_month: (((o[indexCur].price - o[indexPrev].price) / o[indexPrev].price) * 100).toFixed(2),
                      cost_change_current_month: (((leadIncrease - pricePrev) / pricePrev) * 100).toFixed(2),
                      approvedFromValid: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                    })
                  }
                  indexPrev = indexCur
                  indexCur = indexCur + 1
                })
              })
            }
            map(storageCountry, (b, countryId) => {
              let totalAll = 0
              let totalApproved = 0
              let byTotalAprrovedPercent = 0
              let byTotalExpenses = 0
              indexCur = 0
              indexPrev = 0
              let indexCount = 0
              let totalAllCountryKc = 0
              /* pricePrev = b[b.length - 2].expenses_by_lead */
              /* if (!this.other[countryId]) {
                this.other[countryId] = {}
              } */
              map(b, (g, index) => {
                if (!g.expenses_by_lead) {
                  g.expenses_by_lead = 0
                  byTotalExpenses += Number(g.expenses_by_lead) * Number(g.approved)
                  totalAllCountryKc += Number(g.expenses_by_kc)
                } else {
                  byTotalExpenses += Number(g.expenses_by_lead) * Number(g.approved)
                  totalAllCountryKc += Number(g.expenses_by_kc)
                }
                totalAll += parseInt(g.leads)
                totalApproved += parseInt(g.approved)
                byTotalAprrovedPercent += parseInt(g.approved) / parseInt(g.leads)
                indexCount = index + 1
                /* this.other[countryId][g.dateByRows] = {}
                if (parseInt(b[indexCur].expenses_by_lead) === 0 && parseInt(b[indexPrev].expenses_by_lead) === 0) {
                  this.other[countryId][g.dateByRows] = {
                    dateByRows: g.dateByRows,
                    cost_change_other_month: 0,
                    cost_change_current_month: (((g.expected_lead_increase - pricePrev) / pricePrev) * 100).toFixed(2)
                  }
                } else if (parseInt(b[indexPrev].expenses_by_lead) === 0) {
                  this.other[countryId][g.dateByRows] = {
                    dateByRows: g.dateByRows,
                    cost_change_other_month: 0,
                    cost_change_current_month: (((g.expected_lead_increase - pricePrev) / pricePrev) * 100).toFixed(2)
                  }
                } else {
                  this.other[countryId][g.dateByRows] = {
                    dateByRows: g.dateByRows,
                    cost_change_other_month: (((b[indexCur].expenses_by_lead - b[indexPrev].expenses_by_lead) / b[indexPrev].expenses_by_lead) * 100).toFixed(2),
                    cost_change_current_month: (((g.expected_lead_increase - pricePrev) / pricePrev) * 100).toFixed(2)
                  }
                } */
                indexPrev = indexCur
                indexCur = indexCur + 1
              })
              if (!this.footAll[countryId]) {
                this.footAll[countryId] = {}
              }
              this.footAll[countryId] = {
                total: (totalAll / indexCount).toFixed(0),
                totalApproved: (totalApproved / indexCount).toFixed(0),
                totalApprovedPercent: ((byTotalAprrovedPercent / indexCount) * 100).toFixed(2),
                totalKc: (totalAllCountryKc / indexCount).toFixed(0),
                approvedFromValid: Helper.approvedFromValid(totalApproved, total, totalSpam)
              }
            })
            this.rowsAll = storageCountry
            this.footColumns.push({
              total: (total / count).toFixed(0),
              totalApproved: (totalApproved / count).toFixed(0),
              totalApprovedPercent: (totalApprovedPercent / count),
              totalKc: (totalAllKC / count).toFixed(0),
              approvedFromValid: Helper.approvedFromValid(totalApproved, total, totalSpam)
            })
            this.loading = false
            this.$root.$emit('data_loaded')
          }).catch(error => {
            console.log(error)
          })
        },
        changeElem (cell, value) {
          this.oldValue = cell
          this.ChangeValue = value
        },
        getDays (month, year) {
          return new Date(year, month, 0).getDate()
        },
        getCountry () {
          API.getCountries()
              .then(res => {
                Storage.countries = res.body
              })
              .catch(error => {
                console.log(error)
              })
        },
        checkForm: function (e) {
          let post = []
          let month, country
          map(e.target.elements, elem => {
            if (elem.name) {
              month = elem.id.substring(1)
              country = elem.name.substring(1)
              post.push({
                'country_id': country,
                'month': month,
                'price': elem.value
              })
            }
          })
          API.postRentabilityExpenseExpection(post).then(res => {
            this.getData()
          })
              .catch(response => {
                this.$root.$emit('data_loaded')
                this.$notify({
                  type: 'danger',
                  title: this.$root.$t('verbs.error'),
                  text: !response.body.message ? response.body : response.body.message,
                  animationType: 'velocity'
                })
              })
          e.preventDefault()
        }
      }
}

</script>
<style scoped>
    .container-fluid {
        padding: 0;
    }
    .input-price {
        border-radius: 10px;
        padding: 0 30px;
        text-align: center;
        box-shadow: none;
        width: 100px;
        background: transparent;
        outline: none;
        border: none;
    }
    .input-price:hover {
        cursor: pointer;
    }
    .input-price:focus {
        border-radius: 0;
        padding: 0px 20px;
        box-shadow: none;
        width: 100px;
        background: transparent;
        outline: none;
        border: 1px solid #1d92dc;
    }
    .card-header-title {
        margin-left: 135px;
        margin-top: 25px;
        padding: 0;
        margin-bottom: 35px;
        font-size: 1.5em;
        text-align: center;
        height: 100%;
    }
    .was-empty {
        background: #114868 !important;
    }
    .not-empty {
        background-color: #90caf9;
    }
    .card-block {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// ExpectedExpensesKC.vue?150a1761